import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<PublicPages::MwPublicJoin @model={{@model}} @theme=\"event\" />",{ moduleName: "mewe/pods/components/routable/join-event/template.hbs" })